module.exports = __webpack_public_path__ + "img/step2-en.de968c56.webp";